import React from "react";

import Logo_Large from "~/assets/mirage-logo-large.svg?react";
import Logo_Small from "~/assets/mirage-logo-small.svg?react";
import { css, cx } from "~/styled-system/css";

const baseLogoStyles = css({
  color: "$gray.700",
  display: "inline-flex",
  background: "none",
  border: "none",
  padding: 0,
  transformOrigin: "center",
  transform: "scale(var(--scale, 1))",
  transition: "color 0.3s ease-out, filter 0.3s ease-out, --scale 0.3s ease-out",
  "--scale": "1",
});

const interactiveStyles = css({
  cursor: "pointer",
  "&:hover": {
    "--scale": "1.05",
    color: "white",
    filter: "drop-shadow(0 0 8px rgba(255, 255, 255, 0.5))",
  },
  "&[data-animating]": {
    transform: "scale(var(--scale, 1)) rotate(360deg)",
    transition: "transform 0.5s cubic-bezier(0.34, 1.56, 0.64, 1)",
  },
});

interface MirageLogoSmallProps {
  className?: string;
  isInteractive?: boolean;
}

export function MirageLogoSmall({ className, isInteractive = false }: MirageLogoSmallProps) {
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (!isInteractive) {
      return;
    }

    const element = event.currentTarget;
    element.dataset.animating = "";

    // Reset animation state after animation completes
    setTimeout(() => {
      delete element.dataset.animating;
      // Force a reflow to allow the animation to restart
      element.getBoundingClientRect();
    }, 500);
  };

  const Element = isInteractive ? "button" : "div";

  return (
    <Element
      type={isInteractive ? "button" : undefined}
      className={cx(baseLogoStyles, isInteractive && interactiveStyles, className)}
      onClick={handleClick}
    >
      <Logo_Small />
    </Element>
  );
}

export function MirageLogoLarge({ className }: { className?: string }) {
  return (
    <div className={cx(baseLogoStyles, className)}>
      <Logo_Large />
    </div>
  );
}
